import { logger as LOG, logger } from '@garnish/logger';

// ─── Logger ──────────────────────────────────────────────────────────────────

LOG.enable('ORDERING STATE MACHINE');

export const orderingMachineLogger = logger.extend('ORDERING STATE MACHINE');
